import React from "react";
import { v4 as uuidv4 } from "uuid";

import { Box, Typography } from "@material-ui/core";
import { Tags } from "../../../hook/InputFields";
import SwitchFields from "../../../hook/SwitchFields";
import useStyles from "./style";
import StringUtils from "../../../utils/stringUtils";
import fixedData from "./fixedData";

export default function FormPesquisaCreditoPart1(props) {
  const classes = useStyles({ mediaquery: props.mediaquery });
  let objDescriptionclass = !props.mediaquery
    ? {
        marginTop: "1.5rem",
        marginBottom: "1.5rem",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      }
    : { width: "55ch", marginTop: "32px" };

  return (
    <>
      <Typography component="div">
        <Box
          fontSize={20}
          textAlign={!props.mediaquery ? "center" : "start"}
          fontWeight="fontWeightRegular"
        >
          Para começar, selecione o tipo de consulta
        </Box>
      </Typography>
      <Box my={8}>
        {SwitchFields(fixedData.selectDocument(), {
          handleChange: props.handleDocument,
          value: props.document,
          mediaquery: props.mediaquery,
        })}
        {SwitchFields(fixedData.selectTypeOfQuery(props), {
          handleChange: props.handleRelatorios,
          value: props.relatorios,
          mediaquery: props.mediaquery,
        })}

        {props.modelos.map((e, i) => {
          if (e.id == props.relatorios && e.parametros_portal) {
            return (
              <div key={i + uuidv4()} className={classes.objDescriptionclass}>
                <Typography
                  className={classes.objDescriptionclass}
                  key={i + uuidv4()}
                  component="div"
                >
                  <Box
                    fontSize={16}
                    fontWeight="fontWeightBold"
                    textAlign={!props.mediaquery ? "center" : "start"}
                  >
                    Descrição
                  </Box>
                  <Box textAlign={!props.mediaquery ? "center" : "start"}>
                    {e.parametros_portal.description_parameters.description}
                  </Box>
                </Typography>
                <div className={classes.objTagclass}>
                  {props.modelos.map((e) => {
                    if (
                      e.id == props.relatorios &&
                      e.parametros_portal &&
                      e.parametros_portal.description_parameters
                    ) {
                      {
                        return e.parametros_portal.description_parameters.tags.map(
                          (e, i) => (
                            <Tags key={`${i + uuidv4()}`} description={e} />
                          )
                        );
                      }
                    }
                  })}
                </div>

                {props.modelos.map((e, i) => {
                  if (e.id == props.relatorios) {
                    return (
                      <Typography
                        style={objDescriptionclass}
                        key={i + uuidv4()}
                        component="div"
                      >
                        <Box
                          fontSize={12}
                          fontWeight="fontWeightBold"
                          textAlign={!props.mediaquery ? "center" : "start"}
                        >
                          Valor da Pesquisa
                        </Box>
                        <Box
                          fontSize={12}
                          textAlign={!props.mediaquery ? "center" : "start"}
                        >
                          {StringUtils.formatBRL(e.valor)}
                        </Box>
                      </Typography>
                    );
                  }
                })}
              </div>
            );
          }
        })}
      </Box>
    </>
  );
}
